import React, { Component } from "react";
import StarRatingComponent from "react-star-rating-component";
import { QuestionResponseDto } from "src/external/types/questionResponse";

interface RatingProps {
  response: QuestionResponseDto;
  handleChangeRating: (question: QuestionResponseDto, rating: number) => void;
}

interface RatingState {
  response: QuestionResponseDto;
}

class Rating extends Component<RatingProps, RatingState> {
  constructor(props: RatingProps) {
    super(props);
    this.state = {
      response: {
        rating: props.response.rating,
        surveyQuestion: {
          id: props.response.surveyQuestion.id,
          displayOrder: props.response.surveyQuestion.displayOrder,
          question: props.response.surveyQuestion.question
        }
      }
    };
  }

  onStarClick = async (nextValue: any, prevValue: any, name: any) => {
    await this.setState({
      response: {
        surveyQuestion: {
          ...this.props.response.surveyQuestion
        },
        rating: nextValue
      }
    });
    this.props.handleChangeRating(this.props.response, +this.state.response.rating);
  };

  render() {
    const { response } = this.props;
    return (
      <div style={{ fontSize: 28, textAlign: "center" }}>
        <StarRatingComponent
          key={response.surveyQuestion.displayOrder}
          name={response.surveyQuestion.question}
          value={response.rating}
          onStarClick={this.onStarClick}
        />
      </div>
    );
  }
}

export default Rating;
